module.exports = "https://static.wmbcdn.com/uniweb/images/574f5261769bb5b987312ea4e8e313c3.svg";